export default __webpack_public_path__ + "static/media/property_877.bd87e41c.png";